<template>
  <section>
    <div class="container">
        <div class="row justify-content-center my-5">
          <div class="col-10  col-lg-8 " style="margin-top: auto; margin-bottom: auto">
            <p><i class="fas fa-circle fa-xs"></i>Ofrecemos plataformas completamente autoadministrables.</p>
            <p><i class="fas fa-circle fa-xs"></i>Consigue una visión más amplia de tu distribuidora, de una manera fácil <br>
              y certera.</p>
            <p><i class="fas fa-circle fa-xs"></i>Simpleza y efectividad.</p>
            <p><i class="fas fa-circle fa-xs"></i>Solo sube tus archivos a la plataforma y tu información cobrará <br>
              significado.</p>
            <p><i class="fas fa-circle fa-xs"></i>Estadísticas almacenadas en la nube, en todo momento.</p>
            <p class="mb-2" id="fyf"><i class="fas fa-circle fa-xs"></i>Tu información siempre protegida.</p>
          </div>
          <div class="col-lg-4 col-sm-2">
            <img src="../assets/nube_informacion.png" alt="" width="90%" class="img-fluid">
          </div>
        </div>
    </div>
  </section>
</template>

<script>
    export default {
        name: "Home"
    }
</script>

<style scoped>
  i{
    color: var(--primaryColor);
  }
  p{
    margin-bottom: 0px;
  }
  ul {
    list-style: none;
  }

  i::before {
    font-weight: bold;
    display: inline-block;
    width: 1em;
    margin-left: -2em;
  }
</style>
